import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

const Scrollbar = ({ ...props }) => {
  return <SimpleBar {...props} />;
};

export default Scrollbar;
